import { Fragment } from "react";
import "./TeamDivider.css";

// Thin labelled line at the start of each team's block when a list mixes both teams.
export function TeamDivider({ row }) {
  return (
    <div className="team-divider" data-testid={`team-divider-${row.team}`} role="separator" aria-label={row.team}>
      {row.team_logo && <img src={row.team_logo} alt="" loading="lazy" />}
      <span>{row.team}</span>
      <small>{row.home ? "HOME" : "AWAY"}</small>
    </div>
  );
}

export function withTeamDividers(rows, render, enabled = true) {
  const mixed = enabled && new Set(rows.map((r) => r.team)).size > 1;
  return rows.map((r, i) => (
    <Fragment key={`${r.game_id}-${r.player_id}`}>
      {mixed && (i === 0 || rows[i - 1].team !== r.team) && <TeamDivider row={r} />}
      {render(r)}
    </Fragment>
  ));
}
